var exports = {
  "SA": "VoiceConnectionStatus.module__voiceConnectionContainer___TExvWk",
  "jf": "VoiceConnectionStatus.module__statusRow___TExvWk",
  "Tm": "VoiceConnectionStatus.module__channelAvatarStack___TExvWk",
  "kR": "VoiceConnectionStatus.module__signalIcon___TExvWk",
  "rI": "VoiceConnectionStatus.module__statusButton___TExvWk",
  "QQ": "VoiceConnectionStatus.module__statusConnected___TExvWk",
  "Rg": "VoiceConnectionStatus.module__statusConnecting___TExvWk",
  "iA": "VoiceConnectionStatus.module__statusDisconnected___TExvWk",
  "ne": "VoiceConnectionStatus.module__controls___TExvWk",
  "uH": "VoiceConnectionStatus.module__controlButton___TExvWk",
  "wH": "VoiceConnectionStatus.module__selected___TExvWk",
  "Kk": "VoiceConnectionStatus.module__icon___TExvWk",
  "Hd": "VoiceConnectionStatus.module__connectionInfo___TExvWk",
  "J3": "VoiceConnectionStatus.module__channelSourceRow___TExvWk",
  "Dt": "VoiceConnectionStatus.module__channelSourceLink___TExvWk",
  "_R": "VoiceConnectionStatus.module__channelSourceText___TExvWk",
  "wl": "VoiceConnectionStatus.module__channelSourceChannel___TExvWk",
  "EF": "VoiceConnectionStatus.module__channelSourceSeparator___TExvWk",
  "_u": "VoiceConnectionStatus.module__channelSourceGuild___TExvWk",
  "wt": "VoiceConnectionStatus.module__connectionIdRow___TExvWk",
  "TR": "VoiceConnectionStatus.module__connectionIdValue___TExvWk",
  "Gh": "VoiceConnectionStatus.module__connectionIdValueText___TExvWk",
  "Hz": "VoiceConnectionStatus.module__connectionIdIcon___TExvWk",
  "EU": "VoiceConnectionStatus.module__mediaSection___TExvWk",
  "LA": "VoiceConnectionStatus.module__mediaButton___TExvWk",
  "A1": "VoiceConnectionStatus.module__cameraActive___TExvWk",
  "Cb": "VoiceConnectionStatus.module__screenShareActive___TExvWk",
  "cU": "VoiceConnectionStatus.module__mediaIcon___TExvWk",
  "jC": "VoiceConnectionStatus.module__popoutContainer___TExvWk",
  "oO": "VoiceConnectionStatus.module__popoutBodyScroller___TExvWk",
  "$V": "VoiceConnectionStatus.module__popoutBodyContent___TExvWk",
  "hY": "VoiceConnectionStatus.module__popoutHeader___TExvWk",
  "Gb": "VoiceConnectionStatus.module__popoutTitle___TExvWk",
  "IZ": "VoiceConnectionStatus.module__popoutCloseButton___TExvWk",
  "nO": "VoiceConnectionStatus.module__popoutStats___TExvWk",
  "u$": "VoiceConnectionStatus.module__popoutStatsSection___TExvWk",
  "yk": "VoiceConnectionStatus.module__popoutStatsSectionTitle___TExvWk",
  "r6": "VoiceConnectionStatus.module__popoutStatsSectionRows___TExvWk",
  "m1": "VoiceConnectionStatus.module__detailedStatsAccordion___TExvWk",
  "G8": "VoiceConnectionStatus.module__detailedStatsButton___TExvWk",
  "X6": "VoiceConnectionStatus.module__detailedStatsButtonText___TExvWk",
  "VV": "VoiceConnectionStatus.module__detailedStatsCaret___TExvWk",
  "hM": "VoiceConnectionStatus.module__detailedStatsContent___TExvWk",
  "cl": "VoiceConnectionStatus.module__detailedStatsInner___TExvWk",
  "gm": "VoiceConnectionStatus.module__popoutStatRow___TExvWk",
  "Ub": "VoiceConnectionStatus.module__popoutStatLabel___TExvWk",
  "Fz": "VoiceConnectionStatus.module__popoutStatValue___TExvWk",
  "ep": "VoiceConnectionStatus.module__popoutStatTextValue___TExvWk",
  "mp": "VoiceConnectionStatus.module__deviceBadge___TExvWk",
  "Vs": "VoiceConnectionStatus.module__deviceBadgeText___TExvWk",
  "hn": "VoiceConnectionStatus.module__endpointBadge___TExvWk",
  "iu": "VoiceConnectionStatus.module__endpointBadgeText___TExvWk",
  "_v": "VoiceConnectionStatus.module__chartContainer___TExvWk",
  "nS": "VoiceConnectionStatus.module__chartSvg___TExvWk",
  "$s": "VoiceConnectionStatus.module__gridLine___TExvWk",
  "rK": "VoiceConnectionStatus.module__gridLineHorizontal___TExvWk",
  "eB": "VoiceConnectionStatus.module__gridText___TExvWk",
  "BC": "VoiceConnectionStatus.module__chartLine___TExvWk",
  "Pi": "VoiceConnectionStatus.module__chartPoint___TExvWk",
  "Hh": "VoiceConnectionStatus.module__textGreen___TExvWk",
  "NV": "VoiceConnectionStatus.module__textBackgroundModifierHover___TExvWk",
  "Bx": "VoiceConnectionStatus.module__iconSmall___TExvWk",
  "Kt": "VoiceConnectionStatus.module__deviceIcon___TExvWk",
  "hz": "VoiceConnectionStatus.module__lockIcon___TExvWk",
  "Gy": "VoiceConnectionStatus.module__nsModalContent___TExvWk",
  "uU": "VoiceConnectionStatus.module__nsOptions___TExvWk",
};

module.exports = exports;
